module.exports = __webpack_public_path__ + "img/hlhkzxt4.3e4eb3c5.jpg";